import {
  IAssignTagsToClientCommand,
  PaginatedListOfClientInfoDto,
  TagDto,
} from "@growth-machine-llc/stridist-api-client";

import TagsService from "../../../services/TagsService";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import { COACH_CLIENTS_LIST_QUERY_KEY } from "../../coach-clients/CoachClientsListScreen";

export function useAssignClientTag(clientTags?: TagDto[]) {
  return useOptimisticUpdateMutation({
    queryKey: [COACH_CLIENTS_LIST_QUERY_KEY],
    mutationFn: TagsService.assignTagsToClient,
    successToastMessage: "Updated client's tags.",
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfClientInfoDto,
        variables: IAssignTagsToClientCommand,
      ) => {
        if (!oldData) return oldData;

        const updatedItems = oldData?.items?.map((item) => {
          if (item.id === variables.clientId) {
            return {
              ...item,
              tags: clientTags !== undefined ? clientTags : item.tags,
            };
          }
          return item;
        });

        return {
          ...oldData,
          items: updatedItems,
        } as PaginatedListOfClientInfoDto;
      },
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    exactQueryKey: false,
  });
}
